import React from 'react';
import { Link } from 'react-router-dom';

import { Box, Tooltip } from '@mui/material';

import useStyles from './styles';

interface Props {
    label: string;
    tooltip?: string;
    color?: 'default' | 'blue';
    href?: string;
    className?: string;
}

const Tag: React.FC<Props> = ({ label, color = 'default', tooltip = null, href, className }) => {
    const { classes, cx } = useStyles();

    return (
        <Tooltip title={tooltip}>
            <Box
                {...(href
                    ? {
                          component: Link,
                          to: href,
                          target: '_blank',
                          rel: /^https?:\/\//i.test(href) ? 'noopener noreferrer' : undefined
                      }
                    : { component: 'span' })}
                className={cx(
                    classes.root,
                    {
                        [classes._default]: color === 'default',
                        [classes._blue]: color === 'blue',
                        [classes._interactive]: !!href
                    },
                    className
                )}
            >
                {label}
            </Box>
        </Tooltip>
    );
};

export default Tag;
